import { useContext } from 'react';
import AuthContext, { AuthContextProps } from '../context/AuthContext';

const useAuth = (): AuthContextProps => useContext(AuthContext);

export default useAuth;
